import { ENTITY, PLACE_SHORT } from '../constants'
import { ChartField } from './ChartField'
import { Stamp } from './Stamp'

const particulars = [
  { label: 'Entity', value: ENTITY },
  { label: 'Review', value: 'Senior-led on every merge' },
  { label: 'Delivery', value: 'Under NDA' },
  { label: 'Office', value: PLACE_SHORT },
  { label: 'Handover', value: 'Source, runbooks, documentation' },
]

export function TitleSheet() {
  return (
    <section className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 pt-6 pb-0 lg:px-8 lg:pt-8">
        <div className="grid items-stretch gap-6 lg:grid-cols-[1.05fr_1fr] lg:gap-8">
          {/*
            Title block. Stamp rides under the title on narrow sheets so the
            action stays in the first screen; particulars follow.
          */}
          <div className="cell flex flex-col bg-sheet">
            <div className="order-1 border-b border-rule px-5 py-5 sm:px-7 sm:py-7">
              <h1 className="sheet-title text-ink">
                Custom software development with AI
              </h1>
            </div>

            <div className="order-2 flex flex-wrap items-center gap-5 border-b border-rule px-5 py-5 sm:px-7 lg:order-3 lg:border-b-0 lg:border-t">
              <Stamp className="plate plate-over" />
            </div>

            <div className="order-3 grid border-rule sm:grid-cols-[1.15fr_1fr] lg:order-2 lg:border-b">
              <div className="space-y-4 border-b border-rule px-5 py-5 sm:border-b-0 sm:border-r sm:px-7 sm:py-6">
                <p className="text-base leading-relaxed text-ink-muted">
                  We survey the terrain, build the system, and hand it back
                  documented.
                </p>
                <p className="text-base leading-relaxed text-ink-muted">
                  Production software for organizations that outgrew
                  off-the-shelf tools and cannot afford an opaque agency handoff.
                </p>
              </div>

              <dl className="divide-y divide-rule-faint px-5 py-1 sm:px-7">
                {particulars.map((row) => (
                  <div key={row.label} className="py-2.5">
                    <dt className="cell-label text-ink-muted">{row.label}</dt>
                    <dd
                      className="mt-1 text-[0.9375rem] font-medium leading-snug text-ink"
                      style={{ fontStretch: '88%' }}
                    >
                      {row.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>

          <div className="hidden min-h-0 lg:block">
            <ChartField />
          </div>
        </div>
      </div>
    </section>
  )
}
